<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> {{ $t('Create-Ledger') }} </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-flex>
        <v-tabs
          style="width: 100%"
          dark=""
          v-model="modelActive"
          color="blue darken-3"
          slot="extension"
          slider-
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#0">
            {{ $t("tab_general") }}
          </v-tab>
          <v-tab-item :id="'0'" style="width: 100%" class="pa-3">
            <v-flex xs12 sm12 md12>
              <v-layout row wrap>
                <v-flex
                  xs12
                  sm6
                  md6
                  style="padding-right: 2px; padding-bottom: 4px"
                >
                  <v-card color="#1E88E5" class="white--text">
                    <v-layout>
                      <v-flex xs2 sm2 md2>
                        <v-layout
                          align-center=""
                          justify-center=""
                          fill-height=""
                        >
                          <v-icon color="white" large="">receipt</v-icon>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm10 md10>
                        <v-card-title primary-title="">
                          <v-flex xs12 sm12 md12>
                            <v-layout>
                              <v-flex xs12 sm6 md6>
                                <v-list-tile-title>
                                  <span class="subheading font-weight-">
                                    {{ $t('Last-Roll-No') }}
                                  </span>
                                </v-list-tile-title>
                              </v-flex>
                              <v-flex xs12 sm6 md6>
                                <v-list-tile-title>
                                  <span class="subheading font-weight-">
                                    : {{ RegistryItemNo }}
                                  </span>
                                </v-list-tile-title>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-layout>
                              <v-flex xs12 sm6 md6>
                                <v-list-tile-title>
                                  <span class="subheading font-weight-">
                                    {{ $t('Last-Bill-Date') }}
                                  </span>
                                </v-list-tile-title>
                              </v-flex>
                              <v-flex xs12 sm6 md6>
                                <v-list-tile-title>
                                  <span class="subheading font-weight-">
                                    : {{ RecieptDate | dateformat }}
                                  </span>
                                </v-list-tile-title>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-card-title>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex
                  xs12
                  sm6
                  md6
                  style="padding-right: 2px; padding-bottom: 4px"
                >
                  <v-card color="#1E88E5" class="white--text">
                    <v-layout>
                      <v-flex xs2 sm2 md2>
                        <v-layout
                          align-center=""
                          justify-center=""
                          fill-height=""
                        >
                          <v-icon color="white" large="">credit_score</v-icon>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm10 md10>
                        <v-card-title primary-title="">
                          <v-flex xs12 sm12 md12>
                            <v-layout>
                              <v-flex xs12 sm6 md6>
                                <v-list-tile-title>
                                  <span class="subheading font-weight-">
                                    {{ $t('Last-Bill-Number') }}
                                  </span>
                                </v-list-tile-title>
                              </v-flex>
                              <v-flex xs12 sm6 md6>
                                <v-list-tile-title>
                                  <span class="subheading font-weight-">
                                    : {{ desingRecieptNumber(RecieptNumber) }}
                                  </span>
                                </v-list-tile-title>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-layout>
                              <v-flex xs12 sm6 md6>
                                <v-list-tile-title>
                                  <span class="subheading font-weight-">
                                    {{ $t('Last-Line-Number') }}
                                  </span>
                                </v-list-tile-title>
                              </v-flex>
                              <v-flex xs12 sm6 md6>
                                <v-list-tile-title>
                                  <span class="subheading font-weight-">
                                    : {{ desingLineNumber(ReceiptLineNumber) }}
                                  </span>
                                </v-list-tile-title>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-card-title>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 sm12 md12>
              <v-layout row wrap>
                <v-flex xs6 sm4 md3>
                  <tarihim
                    :etiket="$t('Ledger-Date')"
                    v-model="searchParams.EndDate"
                    v-bind:defaultvalue="'ok'"
                  ></tarihim>
                </v-flex>
                <v-flex xs4 sm2 md1 mt-1>
                  <v-btn fab small icon color="info" @click="createBook()">
                    <v-icon>reply</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-tab-item>
          <v-tab href="#1"> {{ $t('PREVIOUS') }} </v-tab>
          <v-tab-item :id="'1'" style="width: 100%" class="pa-3">
            <v-layout row="" wrap="">
              <v-flex pa-1 xs12 sm12 md12>
                <v-card flat>
                  <v-data-table
                    :headers="headersLog"
                    :rows-per-page-items="[50, 100]"
                    :items="LogItems"
                  >
                    <template slot="items" slot-scope="props">
                      <tr item>
                        <td class="text-xs-left">
                          {{ props.item.UserName }}
                        </td>
                        <td class="text-xs-left">
                          {{ props.item.ProcessDescription }}
                        </td>
                        <td class="text-xs-left">
                          {{ props.item.ProcessDate | dateformat }}
                          {{ props.item.ProcessDate | timeformat }}
                        </td>
                        <td class="text-xs-left">
                          <v-icon @click="openProcces(props.item.ProcessText)">
                            search</v-icon
                          >
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
            </v-layout>
          </v-tab-item>
        </v-tabs>
      </v-layout>
    </v-card>
    <v-dialog v-model="LogRequest" max-width="400px">
      <v-card>
        <v-card-title> {{ $t('Request-Detail') }} </v-card-title>
        <v-card-text>{{ LogRequestData }}</v-card-text>
        <v-card-actions
          ><v-btn @click="LogRequest = false">Kapat</v-btn></v-card-actions
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import auth from "../../../../api/auth";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import moment from "moment"
export default {
  data() {
    return {
      modelActive: null,
      LogRequest: false,
      LogRequestData: null,
      LogItems: [],
      headersLog: [
        {
          text: this.$t('User'),
        },
        {
          text: this.$t('Process'),
        },
        {
          text: this.$t('Transaction-Date'),
        },
        {
          text: this.$t('Transaction-details'),
        },
      ],
      searchParams: {
        CompanyID: 0,
        FirstDate: null,
        EndDate: null,
        UserID: 0,
      },
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      RegistryItemNo: 0,
      RecieptNumber: 0,
      RecieptDate: null,
      ReceiptLineNumber: 0,
      DateWillCreate: null,
    };
  },
  methods: {
     openProcces(dialogText) {
      this.LogRequest = true;
      this.LogRequestData = dialogText;
    },
    desingLineNumber(val) {
      if (typeof val != "undefined") {
        switch (val.toString().length) {
          case 1:
            return "00000" + val;
          case 2:
            return "0000" + val;
          case 3:
            return "000" + val;
          case 4:
            return "00" + val;
          case 5:
            return "0" + val;
          case 6:
            return val;
          default:
            break;
        }
      }
    },
    desingRecieptNumber(val) {
      if (typeof val != "undefined") {
        switch (val.toString().length) {
          case 1:
            return "000000000" + val;
          case 2:
            return "00000000" + val;
          case 3:
            return "0000000" + val;
          case 4:
            return "000000" + val;
          case 5:
            return "00000" + val;
          case 6:
            return "0000" + val;
          case 7:
            return "000" + val;
          case 8:
            return "00" + val;
          case 9:
            return "0" + val;
          case 10:
            return val;
          default:
            break;
        }
      }
    },
    createBook() {
      this.loadingvmodel = true;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      this.searchParams.CompanyID = credentials.MuhasebeSirketNo;
      this.searchParams.UserID = credentials.UserID;
      this.$http
        .post(
          auth.API_URL + "api/AccountingRegistry/RegistrySave",
          this.searchParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.snackbar = true;
             this.text1 = this.$t(response.body.ResponseMessage);
            this.getRegistryInfo();
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    getLogList() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      let params = {
        CompanyID: credentials.MuhasebeSirketNo,
        UserID: 0,
        FirstDate: null,
        EndDate: null,
      };
      this.$http
        .post(auth.API_URL + "api/AccountingLogs/LogRegistryList", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.LogItems = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    getRegistryInfo() {
      this.loadingvmodel = true;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      let params = {
        CompanyID: credentials.MuhasebeSirketNo,
      };
      this.$http
        .post(auth.API_URL + "api/AccountingRegistry/RegistryLastInfo", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.RegistryItemNo = response.body.RegistryItemNo;
            this.RecieptNumber = response.body.RecieptNumber;
            this.RecieptDate = response.body.RecieptDate;
            this.ReceiptLineNumber = response.body.ReceiptLineNumber;
            this.DateWillCreate = response.body.DateWillCreate;
            this.searchParams.EndDate = this.DateWillCreate;
            if(this.searchParams.EndDate == null)
          {
            this.searchParams.EndDate= this.RecieptDate;
//            var start=this.searchParams.EndDate.substring(0,10);
//            console.log(start);
//this.searchParams.EndDate=start;
this.searchParams.EndDate=moment(this.searchParams.EndDate).add(1, 'months').toISOString();
this.searchParams.EndDate=moment(this.searchParams.EndDate).endOf( 'months').toISOString();
          }
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            } else {
              this.loadingvmodel = false;
              this.text1 = "Service Unavailable";
              this.snackbar = true;
            }
          }
        );
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    tarihim,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
  
    if (this.sayfayetki.Status == true) {
      this.getRegistryInfo();
      this.getLogList();
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
    timeformat: function (t) {
      return helpers.getTime(t);
    },
  },
};
</script>

<style>
</style>

